var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7197 3.71953L2.80545 15.6338C2.28974 16.1495 2 16.849 2 17.5783V21.2499C2 21.6641 2.33579 21.9999 2.75 21.9999H6.42157C7.15091 21.9999 7.85039 21.7102 8.36613 21.1944L20.2803 9.28017C21.8158 7.74464 21.8158 5.25506 20.2803 3.71953C18.7448 2.18398 16.2552 2.18399 14.7197 3.71953ZM15.7803 4.78017C16.73 3.83043 18.27 3.83043 19.2197 4.78017C20.1694 5.72992 20.1694 7.26978 19.2197 8.21953L17.75 9.68921L14.3107 6.24985L15.7803 4.78017ZM13.25 7.31051L16.6893 10.7499L7.30545 20.1338C7.07103 20.3682 6.7531 20.4999 6.42157 20.4999H3.5V17.5783C3.5 17.2468 3.63169 16.9289 3.86613 16.6944L13.25 7.31051Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.04f32f2fe9b02d5d4b5a637836749853.svg";
export { ForwardRef as ReactComponent };